import Button from 'components/crm/ui/Button';
import Modal from 'components/crm/ui/Modal';
import useText from 'hooks/useText';
import { useEffect } from 'react';

// Mounted while open only, so that its Escape listener lives with it.
const DeleteConfirmation = ({ busy, onCancel, onConfirm }) => {
  const { text } = useText('comments');
  // The Modal closes on Escape; marked handled first, so that the panel
  // around it stays open.
  useEffect(() => {
    const onKeyDown = (event) =>
      event.key === 'Escape' && event.preventDefault();
    window.addEventListener('keydown', onKeyDown, true);
    return () => window.removeEventListener('keydown', onKeyDown, true);
  }, []);

  return (
    <Modal
      open
      onClose={onCancel}
      title={text('confirmDeleteTitle')}
      width={400}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel}>
            {text('confirmDeleteCancel')}
          </Button>
          <Button
            disabled={busy}
            aria-busy={busy || undefined}
            onClick={onConfirm}
          >
            {text('confirmDeleteSubmit')}
          </Button>
        </>
      }
    >
      <p className="text-sm text-body">{text('confirmDeleteMessage')}</p>
    </Modal>
  );
};

/**
 * Asks before a comment is deleted, for good. « Supprimer » calls
 * `onConfirm`; « Annuler », Escape or the backdrop call `onCancel`.
 */
const CommentDeleteDialog = ({ open, busy = false, onCancel, onConfirm }) =>
  open ? (
    <DeleteConfirmation busy={busy} onCancel={onCancel} onConfirm={onConfirm} />
  ) : null;

export default CommentDeleteDialog;
